export default {
    name: 'JOIN_FILER_OUTSIDE_STATIC3',
    ssn: 'SSN',
    birthDate: 'DOB'
}